import * as Pages from "@/components/Pages";
import * as Spaces from "@/models/spaces";
import * as CrmContacts from "@/models/crmContacts";

interface LoadedData {
  space: Spaces.Space;
  contacts: CrmContacts.CrmContact[];
}

export async function loader({ params }): Promise<LoadedData> {
  const [space, contactsResult] = await Promise.all([
    Spaces.getSpace({ id: params.id, includePermissions: true }),
    CrmContacts.getCrmContacts({ spaceId: params.id }),
  ]);

  return {
    space,
    contacts: contactsResult.contacts ?? [],
  };
}

export function useLoadedData(): LoadedData {
  return Pages.useLoadedData() as LoadedData;
}
